import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface CondensatorProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function Condensator(props: CondensatorProps) {
  return (
    <svg
      width="87"
      height="178"
      viewBox="0 0 87 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 162, left: 40}}
      onClick={props.onClick}
    >
      <path
        d="M28 177C31.9944 177 32 173.011 32 173V147H86V135H32V43H86V31H32V5C32 4.98728 31.9936 1 28 1H20C16.0064 0.99997 16 4.98728 16 5V31H5C5 31 1 31 1 35V39C1 43 5 43 5 43H16V135H5C5 135 1 135 1 139V143C1 147 5 147 5 147H16V173C16 173.011 16.0056 177 20 177H28Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M16 80L16 5.00004C16 5.00004 16 1.00002 20 1.00004L28 1.00002C32 1.00002 32 5.00004 32 5.00004V80"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="24"
        cy="23"
        r="8"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M28 78V72C28 72 28 70 26 70H22C20 70 20 72 20 72L20 78"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 35V39C1 43 5 43 5 43H16V31H5C5 31 1 31 1 35Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M32 43H86V31H32V43Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M16 98L16 173C16 173 16 177 20 177L28 177C32 177 32 173 32 173V98"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="8"
        cy="8"
        r="8"
        transform="matrix(1 0 0 -1 16 163)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M28 100V106C28 106 28 108 26 108H22C20 108 20 106 20 106L20 100"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 143V139C1 135 5 135 5 135H16V147H5C5 147 1 147 1 143Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M32 135H86V147H32V135Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M36 89C36 95.6274 30.6274 101 24 101C17.3726 101 12 95.6274 12 89C12 82.3726 17.3726 77 24 77C30.6274 77 36 82.3726 36 89Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M36 89C36 95.6274 30.6274 101 24 101C17.3726 101 12 95.6274 12 89C12 82.3726 17.3726 77 24 77C30.6274 77 36 82.3726 36 89Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="24"
        cy="89"
        r="8"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path d="M24 79V99" stroke="currentColor" className={partStroke({variant: props.variant})} />
    </svg>
  );
}
